@if (trial$ | async) {
  <kendo-floatingactionbutton
    icon="comment"
    text="Talk to Intel 471"
    rounded="large"
    [offset]="{ x: '30px', y: '30px' }"
    [align]="{ horizontal: 'end', vertical: 'bottom' }"
    positionMode="fixed"
    (click)="contactCyborg()"
  >
  </kendo-floatingactionbutton>
}
